import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {RQ_GET_ORDER_API, RQ_GET_ORDER_BY_FILTER, RQ_GET_USER_ORDERS_LIST_API, RQ_PUT_UPDATE_ORDER_API} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RqUpdateOrder = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rq_update_order'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_PUT_UPDATE_ORDER_API.url.replace('<%= id %>', id);
      return rqCreateRequest(
        {...RQ_PUT_UPDATE_ORDER_API, url},
        formData,
        token,
        null,
      );
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['rq_get_user_orders']);

      queryClient.invalidateQueries(['rq_get_order_details', variables.id]);

      options?.onSuccess?.(data, variables);
    },

    ...options,
  });
};

export const RQGetOrderAPI = (id, token, options={}) =>{
  return useQuery({
    queryKey: ['rq_get_order', {id, token}],
    queryFn: async({queryKey, signal}) =>{
      const {id, token} = queryKey[1];
      if (!token) {throw new Error('Invalid token: Token is required for API request');}

      const url = RQ_GET_ORDER_API.url;

      console.log('Get order data:', {url, token});

      // eslint-disable-next-line no-useless-catch
      try{
        const response = await rqCreateRequest(
          {...RQ_GET_ORDER_API, url},
          null,
          token,
          null,
          signal,
        );

        return response;
      } catch (error){
        throw error;
      }
    },
    ...options,
  });
};
export const RQGetOrderByFilter = (token, filters, options = {}) => {
  return useQuery({
    queryKey: ['rq_get_products_by_filter', token, filters],
    queryFn: async ({queryKey, signal}) => {
      const token = queryKey[1];
      const filtersData = queryKey[2];

      const response = await rqCreateRequest(
        RQ_GET_ORDER_BY_FILTER,
        null,
        token,
        null,
        signal,
        'application/json',
        'application/json',
        filtersData,
      );

      return response;
    },
    enabled: !!filters,
    ...options,
  });
};
export const RQGetAllUserOrderList = (id, token, options={}) =>{
  return useQuery({
    queryKey: ['rq_get_all_users_order', {id, token}],
    queryFn: async({queryKey, signal}) =>{
      const {id, token} = queryKey[1];
      if (!token) {throw new Error('Invalid token: Token is required for API request');}

      const url = RQ_GET_USER_ORDERS_LIST_API.url.replace('<%= id %>', id);

      console.log('Get user data:', {url, token});

      // eslint-disable-next-line no-useless-catch
      try{
        const response = await rqCreateRequest(
          {...RQ_GET_USER_ORDERS_LIST_API, url},
          null,
          token,
          null,
          signal,
        );

        return response;
      } catch (error){
        throw error;
      }
    },
    ...options,
  });
};
